import type {
  AxiosInstance,
  AxiosResponse,
  RawAxiosRequestConfig,
} from "axios";
import globalAxios from "axios";
import { createRequestFunction } from "./common";
import type { Configuration } from "./configuration";

/**
 *
 * @export
 * @interface RequestArgs
 */
export interface RequestArgs {
  url: string;
  options: RawAxiosRequestConfig;
}

/**
 *
 * @export
 * @enum {string}
 */
export enum RequestMethod {
  GET = "GET",
  POST = "POST",
  PUT = "PUT",
  DELETE = "DELETE",
  PATCH = "PATCH",
}

/**
 *
 * @export
 * @class BaseAPI
 */
export class BaseAPI<D = {}, R = {}> {
  protected route = "";
  protected method: RequestMethod = RequestMethod.GET;
  protected params: string[] = [];

  constructor(
    protected configuration: Configuration,
    protected axios: AxiosInstance = globalAxios,
  ) {
    if (configuration) {
      this.configuration = configuration;
    }
  }

  public call(
    data: D,
    options?: RawAxiosRequestConfig,
  ): Promise<AxiosResponse<R, any>> {
    let route = this.route;
    const useMockApi = this.axios.defaults.useMockApi;
    if (useMockApi) {
      this.configuration.basePath = "http://localhost:3000";
    }

    if (this.params.length > 0) {
      for (const param of this.params) {
        const paramData = data[param as keyof D] as string;
        route = this.route.replace(`{${param}}`, paramData);
        delete data[param as keyof D];
      }
    }
    const axiosArgs: RequestArgs = {
      url: useMockApi
        ? "/mocks" +
          (route.includes("?")
            ? route.split("?")[0] + ".json?" + route.split("?")[1]
            : route + ".json")
        : route,
      options: {
        ...options,
        method: useMockApi ? RequestMethod.GET : this.method,
        data,
      },
    };

    const request = createRequestFunction(
      axiosArgs,
      globalAxios,
      this.configuration,
    );

    return request<R>(this.axios);
  }
}
